import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { ApplicationState } from '../types/state/storeTypes';
import { CollectionsShowResponse } from '../types/api/CollectionsShowTypes';

import { addMultipleToOwnershipsCache, addNotOwnedProductId } from '../state/actions/ownershipsCacheActions';
import { addToCollectionsCache } from '../state/actions/collectionsCacheActions';
import { collectionAlreadyCached } from '../helpers/state/actions/collectionCacheActionHelpers';

export default function resolveProductModal(product: any) {
  const dispatch = useDispatch();
  const state: ApplicationState = useSelector((state) => state) as ApplicationState;

  const [error, setError] = useState(null);
  const [loadingCollection, setLoadingCollection] = useState<boolean>(false);
  const [collection, setCollection] = useState(null);
  const [loadingOwnership, setLoadingOwnership] = useState<boolean>(false);
  const [ownership, setOwnership] = useState(null);

  useEffect(() => {
    const fetchCollection = async () => {
      const collectionsCache = state.collectionsCache.collections;
      if (collectionAlreadyCached(collectionsCache, null, product.collection_id)) {
        setCollection(collectionsCache.find((collection: CollectionsShowResponse) => collection.id === product.collection_id));
        return;
      }
      setLoadingCollection(true);
      dispatch({
        type: '',
        api: {
          method: 'GET',
          url: `/collections/${product.collection_id}`,
          onError: (res: any) => {
            setLoadingCollection(false);
            setError(res);
            return false;
          },
          onSuccess: (res: any) => {
            setCollection(res.data);
            dispatch(
              addToCollectionsCache(res.data)
            );
            setLoadingCollection(false);
          }
        }
      });
    }

    const fetchOwnership = async () => {
      if (!state?.auth?.user?.token) return;
      if (state?.ownershipsCache?.ownerships[product.id]) {
        setOwnership(
          state?.ownershipsCache?.ownerships[product.id]
        )
        return;
      }
      if (state?.ownershipsCache?.notOwnedProductsIds?.find((productId: number) => product.id === productId)) {
        setOwnership(null);
        return;
      }
      setLoadingOwnership(true);
      dispatch({
        type: '',
        api: {
          method: 'GET',
          url: `/products/${product.collection_id}/ownership`,
          headers: { authorization: state.auth.user.token },
          onError: (res: any) => {
            setLoadingOwnership(false);
            setError(res);
            return false;
          },
          onSuccess: (res: any) => {
            dispatch(addMultipleToOwnershipsCache(res.data.data));
            const productOwnership = res.data.data[product.id];
            if (!productOwnership)
              dispatch(addNotOwnedProductId(product.id));
            setOwnership(productOwnership || null);
            setLoadingOwnership(false);
          }
        }
      });
    }

    fetchCollection();
    fetchOwnership();
  }, []);

  return { error, loadingCollection, ownership, collection, loadingOwnership, };
}
